import React, { useEffect, useRef, useState } from "react";
import html2canvas from "html2canvas";
import "./cetification.css";
import { useCertification } from "../../useSeo";
import { useParams } from "react-router-dom";
const CertificationCard = () => {
  const config = useCertification();
  const certificateRef = useRef(null);
  const [users, setUsers] = useState([]);
  const [loading, setloading] = useState(false);
  const [error, setError] = useState(null);
  const { id } = useParams();

  useEffect(() => {
    async function fetchUsers() {
      try {
        setloading(true);
        const res = await fetch(`https://procoor.com/api/employees/${id}`);
        const data = await res.json();
        if (res.status === 404) {
          throw new Error("User not found");
        }
        setUsers(data);
      } catch (error) {
        setError(error.message);
      }
      setloading(false);
    }

    fetchUsers();
  }, [id]);
  const downloadCertificate = async () => {
    const element = certificateRef.current;
    if (!element) return;

    try {
      const canvas = await html2canvas(element, {
        scale: 2,
        useCORS: true,
        allowTaint: true,
        backgroundColor: "#ffffff",
      });

      const image = canvas.toDataURL("image/png", 1.0);
      const link = document.createElement("a");
      link.href = image;
      link.download = `certificate-${users.data?.name || "user"}.png`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (error) {
      console.error("Error downloading certificate:", error);
    }
  };
  if (loading) {
    <div className="loading-container">
      <div className="spinner"></div>
      <div className="loading-text">loading</div>
    </div>;
  }
  if (error)
    return (
      <section className=" app-section" data-theme="dark">
        <div className="certificate-container ">
          <h2 style={{ color: "red" }}>{error}</h2>
        </div>
      </section>
    );
  return (
    <main>
      <section className=" app-section" data-theme="dark">
        <div style={{ marginTop: "20px" }}>
          <div
            style={{
              display: "flex",
              justifyContent: "end",
              marginRight: "10px",
            }}
          >
            <button
              onClick={downloadCertificate}
              style={{
                padding: "10px 20px",
                backgroundColor: "#294cff",
                color: "white",
                border: "none",
                borderRadius: "5px",
                cursor: "pointer",
                fontSize: "16px",
              }}
            >
              Download
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="20"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
                className="lucide lucide-arrow-down-to-line-icon lucide-arrow-down-to-line"
              >
                <path d="M12 17V3" />
                <path d="m6 11 6 6 6-6" />
                <path d="M19 21H5" />
              </svg>
            </button>
          </div>

          <div className="certificate-container">
            <div className="certificate" ref={certificateRef}>
              <div className="certificateBorder">
                <div className="certificate-badge">
                  <img src="/assets/images/Logo.svg" alt="Procoor Logo" />
                </div>
                {/* Header */}
                <div className="certificateData">
                  <div className="certificate-header">
                    <h1>CERTIFICATE OF </h1>
                    <h1> TRAING COMPLETION</h1>
                    <p className="presentation-text">
                      THIS TRINING CERTIFICATE IS PROUDLY PRESENTED TO
                    </p>

                    <div className="headerLineContainer">
                      <div className="header-line left"></div>

                      <div className="header-line right"></div>
                    </div>
                  </div>

                  {/* Content */}

                  <div className="recipient-name">{users.data?.name}</div>

                  <div className="recipientNameLine"></div>

                  <div className="achievement-title">
                    <p>
                      {" "}
                      To Certify The Completion of training in using Procoor as
                      a{config.SectionName}
                    </p>
                    <p>
                      {" "}
                      System at the {users.data?.experience} at Procoor Academy{" "}
                    </p>
                    <p>The training was completed in the following:</p>
                    <p>{users.data?.module} Module</p>
                    <p>PR-PM-ST-01</p>
                  </div>
                  <div style={{ display: "flex" }}>
                    <div className="procoorSign">
                      <img src={config.SignatureSrc} alt="Signature" />
                      <div className="signature-line"></div>
                      <div className="issuer-name">
                        Procoor Academy Management
                      </div>
                    </div>
                    <div className="Signature">
                      <img src={config.Stamp} alt="Stamp" />
                    </div>
                  </div>

                  {/* Footer */}
                  <div className="certificate-footer">
                    <div className="footer-details">
                      <div className="date-issued">
                        <span>CERTIFCATE NO : {config.CertificateNO}</span>
                      </div>

                      <div className="date-issued">
                        <span>DATE : {config.Date} </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </main>
  );
};

export default CertificationCard;
